export default __webpack_public_path__ + "../staticImages/award-2023-ntv.png";